import Image from 'global/Image';
import { useState } from 'react';

import { ImagePlaceholder } from './styled';

type CompanyIconProps = {
  symbol: string;
  avatar_url: string;
  size?: number;
};

const CompanyIcon = ({ symbol, avatar_url, size = 20 }: CompanyIconProps) => {
  const [isIconAvailable, setIsIconAvailable] = useState(true);

  if (isIconAvailable) {
    return (
      <Image
        src={avatar_url}
        alt=""
        width={size}
        height={size}
        onError={() => setIsIconAvailable(false)}
      />
    );
  }

  return (
    <ImagePlaceholder size={size}>
      <small>{!!symbol && symbol.toUpperCase().slice(0, 1)}</small>
    </ImagePlaceholder>
  );
};

export default CompanyIcon;
